import { Component, OnInit, input, signal } from '@angular/core';
import { BipModel } from '../../../core/api/models';
import { AccountApiService, StaffApiService } from '../../../core/api/services';
import { AlertService } from '../../../shared/services/alert.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
    selector: 'app-bip-list',
    templateUrl: './bip-list.component.html',
    styleUrl: '../../supervisor-main.component.css',
    standalone: false,
})
export class BipListComponent implements OnInit {
    patientID = input.required<string>();
    loading = signal<boolean>(false);
    rows = signal<BipModel[]>([]);

    signVisible = false;
	previewVisible = false;
    previewBlob: Blob | null = null;
    selectedBip: BipModel | null = null;
    userName: string = '';
    signatureUrl: string | null = null;
    signing = false;
    canEditBip = false;

    constructor(private staffApi: StaffApiService, private alerts: AlertService, private authService: AuthService, private accountApi: AccountApiService) { }

    ngOnInit(): void {
        this.canEditBip = this.authService.canEditBip();
        this.load();
        const user = this.authService.userInfo;
        this.userName = (user?.Fullnane || user?.UserName || '').trim();
        if (this.canEditBip) {
            this.accountApi.GetUserSignature().subscribe({
                next: (data) => { this.signatureUrl = URL.createObjectURL(data); },
                error: () => { console.log('Failed to load user signature'); }
            });
        }

    }

    load() {
        this.loading.set(true);
        this.staffApi.GetPatientBIPs({ patientID: Number(this.patientID()) }).subscribe({
            next: list => { this.rows.set(list || []); this.loading.set(false); },
            error: () => { this.alerts.error('Failed to load BIPs'); this.loading.set(false); }
        });
    }

	openPdf(bip: BipModel) {
		this.previewBlob = null;
		this.staffApi.GetBipPdf({ patientID: Number(this.patientID()), bipID: bip.ID }).subscribe({
			next: (data) => { this.previewBlob = data;  },
			error: () => { this.alerts.error('Failed to load BIP PDF'); }
		});
        this.previewVisible = true;
	}

    finish(bip: BipModel) {
        if (!this.canEditBip) {
            this.alerts.info('You do not have permission to sign BIPs.');
            return;
        }
        this.selectedBip = bip;
        this.previewBlob = null;
        this.staffApi.GetBipPdf({ patientID: Number(this.patientID()), bipID: bip.ID }).subscribe({
            next: (data) => { this.previewBlob = data; },
            error: () => { this.alerts.error('Failed to load BIP PDF'); }
        });
        this.signVisible = true;
    }

    async confirmSign() {
        if (!this.canEditBip) return;
        this.signing = true;
        if (!this.selectedBip?.ID) {
            this.signing = false;
            return;
        }
        this.staffApi.FinishAndSignBIP({ body: { PatientID: Number(this.patientID()), BIPID: this.selectedBip.ID } }).subscribe({
            next: () => { this.alerts.success('BIP signed'); this.signing = false; this.signVisible = false; this.load(); },
            error: () => {this.alerts.error('Failed to sign BIP'); this.signing = false;}
        });
    }

}


